<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Travel: Unconfirmed</h3>
    </div>
  </div>

  <div class="row top10">
    <div class="col-xs-12">
      <aims-common-table
        id="trvl-unconfirmed-table"
        [dataSource]="unconfirmedTravel | async"
        [header]="tableHeader"
        [permissions]="tablePermissions | async"
        [pageSize]="15"
        [stickyHeader]="true">
        <aims-common-table-dynamic-row id="returnOn">
          <ng-template viewMode let-element >
            <ng-container *ngIf="element.returnOn == null">
              OPEN
            </ng-container>
            <ng-container *ngIf="element.returnOn != null">
              {{element.returnOn | date: 'mediumDate'}}
            </ng-container>
          </ng-template>
          </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>
</div>
